<template>
  <div class="dashboard__grid dashboard-card__no-min dash-library__content-container dash-library__content-container--no-min h-no-padding">
    <div class="dashboard__grid dash-library__content-container dash-library__content-container--no-min" v-if="contacts">
      <div class="col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered">
        <div class="row">
          <div v-for="(group, index) in groups" :key="index" class="col-md-6">
            <Contact v-for="(contact, index) in group" :key="`contact-${index}`" :contact="contact"></Contact>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard__grid dashboard__alert alert alert-warning" v-else-if="loaders.contacts == false && initializers.contacts == true">
      <div class="dashboard__no-data">No contact information available</div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Contact from './Contact.vue';

  export default {
    name: 'Contacts',
    components: {
      Contact,
    },
    computed: {
      ...mapGetters('contacts', ['loaders', 'initializers', 'contacts']),
      colNum() {
        return Math.ceil(this.contacts.length/2);
      },
      groups() {
        return lodash.chunk(this.contacts, this.colNum);
      },
    },
    mounted() {
      if (!this.initializers.contacts) {
        this.$store.dispatch('contacts/getContacts');
      }
    },
  };
</script>
